import * as React from "react";

import { Icon } from "@fluentui/react";

import { iconNameToIconProps } from "@1js/acui-icons";

import { AppButtonState } from "../components/AppButton/next";

/**
 * Minimum properties associated with setting the FontIcon.
 *
 * Original `icon` property in the Fabric-based controls in app-commanding-ui was a string property. That has been
 * replaced with `iconName`. The Fluent UI-based controls have an `icon` state property that is a shorthand property.
 */
export type StateWithIconAsStringOrShorthand = {
  icon?: AppButtonState["icon"];
  iconName?: string;
  iconColor?: string;
};

/**
 * Process the `state` as a mutable object, converting a Fabric-based string `icon` property (if it exists) to a
 * Fluent UI-based shorthand `icon` property.
 */
export function useShorthandFontIcon(state: StateWithIconAsStringOrShorthand) {
  if (typeof state.icon?.children === "string") {
    const {
      icon: { children: iconAsString },
      iconName,
      iconColor,
    } = state;
    const iconNameResolved = iconName ?? (iconAsString as string);

    state.icon = {
      children: <Icon {...iconNameToIconProps(iconNameResolved, iconColor)} />,
    };
  }
}
